import React, { PropsWithChildren } from "react";
import {
  IRouter,
  RouterProvider,
  SiteConfigurationProvider,
} from "@atlassiansox/bxp-ui-sdk";
import {
  StargateClient,
  StargateClientProvider,
} from "@atlassiansox/bxp-react-stargate";
import Environment from "../../common/environment";

/**
 * SurfaceRouter
 * Routing Implementation
 */
class SurfaceRouter implements IRouter {
  public readonly baseUrl: string;

  public constructor(baseUrl: string) {
    this.baseUrl = baseUrl;
  }

  public locale = document.documentElement.lang;

  public async push(urlPath: string) {
    window.location.href = urlPath;
  }
}

/**
 * SurfaceProvider
 * Returns all Surface-related Providers, to be used by the main app mounting point.
 */
export function SurfaceProvider({ children }: PropsWithChildren) {
  return (
    <SiteConfigurationProvider
      configuration={{
        baseUrlWac: Environment.getBaseURL(),
        signupGoogleRecaptchaToken: Environment.isProduction()
          ? "6LeTa5ocAAAAAJefQaFL-1ENlPNY3Wq2j-GhcZ6n"
          : "6Lf0JekdAAAAAAWT2kBc89gFVKhxkwTPxa-e9tvx",
        pricingUseGeoCurrency: LOCALIZED_PRICING_USE_GEO_CURRENCY,
        pricingContentfulSpace: LOCALIZED_PRICING_CONTENTFUL_SPACE,
        pricingContentfulEnvironment: LOCALIZED_PRICING_CONTENTFUL_ENVIRONMENT,
        pricingContentfulAccessToken: LOCALIZED_PRICING_CONTENTFUL_ACCESS_TOKEN,
        ccpPricingContentfulEnvironment:
          LOCALIZED_CCP_PRICING_CONTENTFUL_ENVIRONMENT,
        ccpPricingContentfulAccessToken:
          LOCALIZED_CCP_PRICING_CONTENTFUL_ACCESS_TOKEN,
        wacIntegrationUrl: Environment.getWacIntegrationUrl(),
        identityBaseUrl: Environment.getIdentityBaseUrl(),
        productTld: Environment.getProductTld(),
      }}
    >
      <RouterProvider router={new SurfaceRouter(Environment.getBaseURL())}>
        <StargateClientProvider
          client={
            new StargateClient({
              baseUrl: Environment.getAPIPrivateURL(),
            })
          }
        >
          {children}
        </StargateClientProvider>
      </RouterProvider>
    </SiteConfigurationProvider>
  );
}
